import { fork } from "redux-saga/effects";

import watchPermissionMasterDataState from "./permission/sagas";
import watchUserMasterData from "./user/sagas";
import watchUsergroupMasterDataState from "./usergroup/sagas";
import watchCompany from "./company/saga";
import watchPlant from "./plant/saga";
import watchWorkingHour from "./plant-working-hour/saga";
import watchProfile from "./profile/sagas";
import watchPaymentChannel from "./payment/saga";
import watchFaq from "./faq/saga";
import watchPlantAccount from "./plant-account/saga";

import watchSections from "./section/saga";

const watchMasterDataMangement = [
  fork(watchPermissionMasterDataState),
  fork(watchUserMasterData),
  fork(watchUsergroupMasterDataState),
  fork(watchCompany),
  fork(watchPlant),
  fork(watchWorkingHour),
  fork(watchProfile),
  fork(watchPaymentChannel),
  fork(watchFaq),
  fork(watchSections),
  fork(watchPlantAccount),
];

export default watchMasterDataMangement;
